// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Dialogs UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ezDialog-container {
  display: none;
}

.ezDialog-layout-container {
  display: grid;
  grid-template-columns: min-content auto;
  grid-template-rows: auto;
  justify-content: stretch;
  align-content: start;
  grid-column-gap: 10px;
}

.ezDialog-message-container {
  overflow: auto;
}

/* -------------------------------------------------------------------
| JQuery UI Dialog Overrides (default)                               |
------------------------------------------------------------------- */
.ezDialog-content-border-silver {
  margin-top: 10px;
  padding: 8px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

.ezDialog-no-close-button .ui-dialog-titlebar-close {
  display: none;
}

.ezDialog-without-icon {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: auto;
  justify-content: start;
  align-content: start;
  background-color: var(--ezAlphaBackgroundWhite1);
  background-size: var(--ezBackgroundImageSize);
  background-image: var(--ezBackgroundImage);
  color: var(--ezContentFontColor);
  font-size: var(--ezContentFontSize);
  font-family: var(--ezFontFamily);
  font-weight: var(--ezContentFontWeight);
  font-style: var(--ezContentFontStyle);
}

.ezDialog-with-icon {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: min-content auto;
  background-color: var(--ezAlphaBackgroundWhite1);
  background-size: var(--ezBackgroundImageSize);
  background-image: var(--ezBackgroundImage);
  color: var(--ezContentFontColor);
  font-size: var(--ezContentFontSize);
  font-family: var(--ezFontFamily);
  font-weight: var(--ezContentFontWeight);
  font-style: var(--ezContentFontStyle);
}

.ezDialog-icon-container {
  display: grid;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 8px;
  padding-bottom: 8px;
  grid-template-rows: auto;
  grid-template-columns: auto;
  align-content: start;
  justify-content: justify-content;
  background-color: transparent;
}

img.ezDialog-icon {
  padding: 0;
  margin: 0;
  width: 32px;
  height: 32px;
  border-style: none;
}

.ezDialog-content-container {
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-radius: 3px;
}

.ezDialog-content-silver-container_4px {
  padding: 4px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  border-color: var(--ezBorderSilver);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezDialog-content-silver-container_8px {
  padding: 8px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  border-color: var(--ezBorderSilver);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ez-dialog-shadow {
  /* box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.4); */
  box-shadow: 0 0 4px 2px rgb(0 0 0/40%);
}

/*
    @deprecated
    Migrate to: ezDialog-content-container
*/
.ezDialog-content {
  margin-top: 8px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  border-style: none;
}

/*
    @deprecated
    Migrate to classes starting with 'ezDialog-' or
    use ez-padding.css classes.
*/
.ui-corner-all {
  border-radius: 3px;
}

/*
    @deprecated
    Migrate to classes starting with 'ezDialog-' or
    use ez-layout-grid.css classes.
*/
.ez-dialog-no-scroll {
  overflow: hidden;
}

/* Older Dialog Styles */
/*
    @deprecated
    Migrate to classes starting with: ezDialog-
*/
div.ezClockerDialog {
  display: none;
}

/*
    @deprecated
    Migrate to: ezDialog-icon
*/
img.ezClockerDialogImage {
  height: 32px;
  width: 32px;
  margin-top: 0;
  margin-right: 10px;
}

.ezDialog-icon-container {
  display: grid;
  /* Y-Axis */
  align-content: start;
  /* X-Axis */
  justify-content: start;
  padding-left: 10xp;
  padding-right: 10px;
}

.ezDialog-icon {
  margin: 10px;
  height: 32px;
  width: 32px;
}

/*
    @deprecated
    Migrate to classes starting with: ezDialog-
*/
table.ezClockerDialogContent {
  width: 100%;
  border-style: none;
}

/*
    @deprecated
    Migrate to classes starting with: ezDialog-
*/
td.ezClockerDialogImageCell {
  text-align: left;
  vertical-align: top;
  width: 34px;
  border-style: none;
}

/*
    @deprecated
    Migrate to classes starting with: ezDialog-
*/
td.ezClockerDialogMessageCell {
  vertical-align: top;
  text-align: left;
  border-style: none;
}

/*
    @deprecated
    Migrate to: ezDialog-without-icon or ezDialog-with-icon
*/
div.genericDialog {
  padding: 8px;
}

/*
    @deprecated
    Migrate to classes starting with 'ezDialog-' or
    use ez-text.css classes.
*/
.ezDialogTextInputContainerHighlight {
  box-shadow: 0 0 15px 1px #ffcc66;
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1023px) {

}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 768px) {

}
*/
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 480px) {

}
*/
/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 319px) {

}
*/`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-dialogs.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,aAAA;AAAJ;;AAGA;EACI,aAAA;EACA,uCAAA;EACA,wBAAA;EACA,wBAAA;EACA,oBAAA;EACA,qBAAA;AAAJ;;AAIA;EACI,cAAA;AADJ;;AAIA;;qEAAA;AAIA;EACI,gBAAA;EACA,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,aAAA;AAFJ;;AAKA;EACI,aAAA;EACA,wBAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;EACA,gDAAA;EACA,6CAAA;EACA,0CAAA;EACA,gCAAA;EACA,mCAAA;EACA,gCAAA;EACA,uCAAA;EACA,qCAAA;AAFJ;;AAKA;EACI,aAAA;EACA,wBAAA;EACA,uCAAA;EACA,gDAAA;EACA,6CAAA;EACA,0CAAA;EACA,gCAAA;EACA,mCAAA;EACA,gCAAA;EACA,uCAAA;EACA,qCAAA;AAFJ;;AAKA;EACI,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,2BAAA;EACA,oBAAA;EACA,gCAAA;EACA,6BAAA;AAFJ;;AAKA;EACI,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,YAAA;EACA,uCAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,gDAAA;EACA,sCAAA;AAFJ;;AAKA;;;CAAA;AAIA;EACI,eAAA;EACA,uCAAA;EACA,4BAAA;EACA,kBAAA;AAFJ;;AAKA;;;;CAAA;AAKA;EACI,kBAAA;AAFJ;;AAKA;;;;CAAA;AAKA;EACI,gBAAA;AAFJ;;AAKA,wBAAA;AACA;;;CAAA;AAIA;EACI,aAAA;AAFJ;;AAKA;;;CAAA;AAIA;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,YAAA;EACA,YAAA;EACA,WAAA;AAFJ;;AAKA;;;CAAA;AAIA;EACI,WAAA;EACA,kBAAA;AAFJ;;AAKA;;;CAAA;AAIA;EACI,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAFJ;;AAKA;;;CAAA;AAIA;EACI,mBAAA;EACA,gBAAA;EACA,kBAAA;AAFJ;;AAKA;;;CAAA;AAIA;EACI,YAAA;AAFJ;;AAKA;;;;CAAA;AAKA;EACI,gCAAA;AAFJ;;AAKA;;qEAAA;AAGA;;;;CAAA;AAOA;;qEAAA;AAGA;;;;CAAA;AAMA;;qEAAA;AAGA;;;;CAAA;AAMA;;qEAAA;AAGA;;;;CAAA","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| EzClocker Dialogs UX CSS Classes\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n\n.ezDialog-container {\n    display: none;\n}\n\n.ezDialog-layout-container {\n    display: grid;\n    grid-template-columns: min-content auto;\n    grid-template-rows: auto;\n    justify-content: stretch;\n    align-content: start;\n    grid-column-gap: 10px;\n}\n\n\n.ezDialog-message-container {\n    overflow: auto;\n}\n\n/* -------------------------------------------------------------------\n| JQuery UI Dialog Overrides (default)                               |\n------------------------------------------------------------------- */\n\n.ezDialog-content-border-silver {\n    margin-top: 10px;\n    padding: 8px;\n    background-color: var(--ezClockerSilver);\n    color: var(--ezClockerBlack);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\n.ezDialog-no-close-button .ui-dialog-titlebar-close {\n    display: none;\n}\n\n.ezDialog-without-icon {\n    display: grid;\n    grid-template-rows: auto;\n    grid-template-columns: auto;\n    justify-content: start;\n    align-content: start;\n    background-color: var(--ezAlphaBackgroundWhite1);\n    background-size: var(--ezBackgroundImageSize);\n    background-image: var(--ezBackgroundImage);\n    color: var(--ezContentFontColor);\n    font-size: var(--ezContentFontSize);\n    font-family: var(--ezFontFamily);\n    font-weight: var(--ezContentFontWeight);\n    font-style: var(--ezContentFontStyle);\n}\n\n.ezDialog-with-icon {\n    display: grid;\n    grid-template-rows: auto;\n    grid-template-columns: min-content auto;\n    background-color: var(--ezAlphaBackgroundWhite1);\n    background-size: var(--ezBackgroundImageSize);\n    background-image: var(--ezBackgroundImage);\n    color: var(--ezContentFontColor);\n    font-size: var(--ezContentFontSize);\n    font-family: var(--ezFontFamily);\n    font-weight: var(--ezContentFontWeight);\n    font-style: var(--ezContentFontStyle);\n}\n\n.ezDialog-icon-container {\n    display: grid;\n    padding-left: 4px;\n    padding-right: 4px;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    grid-template-rows: auto;\n    grid-template-columns: auto;\n    align-content: start;\n    justify-content: justify-content;\n    background-color: transparent;\n}\n\nimg.ezDialog-icon {\n    padding: 0;\n    margin: 0;\n    width: 32px;\n    height: 32px;\n    border-style: none;\n}\n\n.ezDialog-content-container {\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-radius: 3px;\n}\n\n.ezDialog-content-silver-container_4px {\n    padding: 4px;\n    background-color: var(--ezClockerSilver);\n    color: var(--ezClockerBlack);\n    border-color: var(--ezBorderSilver);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ezDialog-content-silver-container_8px {\n    padding: 8px;\n    background-color: var(--ezClockerSilver);\n    color: var(--ezClockerBlack);\n    border-color: var(--ezBorderSilver);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ez-dialog-shadow {\n    /* box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.4); */\n    box-shadow: 0 0 4px 2px rgb(0 0 0 / 40%);\n}\n\n/*\n    @deprecated\n    Migrate to: ezDialog-content-container\n*/\n.ezDialog-content {\n    margin-top: 8px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n    border-style: none;\n}\n\n/*\n    @deprecated\n    Migrate to classes starting with 'ezDialog-' or\n    use ez-padding.css classes.\n*/\n.ui-corner-all {\n    border-radius: 3px;\n}\n\n/*\n    @deprecated\n    Migrate to classes starting with 'ezDialog-' or\n    use ez-layout-grid.css classes.\n*/\n.ez-dialog-no-scroll {\n    overflow: hidden;\n}\n\n/* Older Dialog Styles */\n/*\n    @deprecated\n    Migrate to classes starting with: ezDialog-\n*/\ndiv.ezClockerDialog {\n    display: none;\n}\n\n/*\n    @deprecated\n    Migrate to: ezDialog-icon\n*/\nimg.ezClockerDialogImage {\n    height: 32px;\n    width: 32px;\n    margin-top: 0;\n    margin-right: 10px;\n}\n\n.ezDialog-icon-container {\n    display: grid;\n    /* Y-Axis */\n    align-content: start;\n    /* X-Axis */\n    justify-content: start;\n    padding-left: 10xp;\n    padding-right: 10px;\n}\n\n.ezDialog-icon {\n    margin: 10px;\n    height: 32px;\n    width: 32px;\n}\n\n/*\n    @deprecated\n    Migrate to classes starting with: ezDialog-\n*/\ntable.ezClockerDialogContent {\n    width: 100%;\n    border-style: none;\n}\n\n/*\n    @deprecated\n    Migrate to classes starting with: ezDialog-\n*/\ntd.ezClockerDialogImageCell {\n    text-align: left;\n    vertical-align: top;\n    width: 34px;\n    border-style: none;\n}\n\n/*\n    @deprecated\n    Migrate to classes starting with: ezDialog-\n*/\ntd.ezClockerDialogMessageCell {\n    vertical-align: top;\n    text-align: left;\n    border-style: none;\n}\n\n/*\n    @deprecated\n    Migrate to: ezDialog-without-icon or ezDialog-with-icon\n*/\ndiv.genericDialog {\n    padding: 8px;\n}\n\n/*\n    @deprecated\n    Migrate to classes starting with 'ezDialog-' or\n    use ez-text.css classes.\n*/\n.ezDialogTextInputContainerHighlight {\n    box-shadow: 0 0 15px 1px #ffcc66;\n}\n\n/* -------------------------------------------------------------------\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 1023px) {\n\n}\n*/\n\n\n/* -------------------------------------------------------------------\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 768px) {\n\n}\n*/\n\n/* -------------------------------------------------------------------\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 480px) {\n\n}\n*/\n\n/* -------------------------------------------------------------------\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 319px) {\n\n}\n*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
